import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import { Box, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PieChart from '../../../../shared/components/PieChart';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { formatDate } from '../../../../shared/functions/formatDate';
import { getRGBAColor } from '../../../../shared/functions/getRGBAColor';
import { IPieChartData } from '../../../../shared/interfaces/shared/IChart';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';

interface IProps {
  title: string;
  chart: IPieChartData;
  colSize?: number;
}
const DashboardChart: React.FC<IProps> = ({ chart, title, colSize = 6 }) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Grid
      size={{
        xs: 12,
        md: colSize,
        lg: colSize - 2,
      }}
    >
      <Card>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              padding: '10px',
              backgroundColor: getRGBAColor('--primaryColor', 0.08),
              borderRadius: '10px',
              color: 'var(--primaryColor)',
            }}
          >
            <QueryStatsOutlinedIcon fill={lightPalette.primary.main} />
          </Box>
          <Typography fontWeight={'500'} sx={{ marginLeft: '10px' }}>
            {title}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {chart && <PieChart data={chart} />}
        </Box>
        <Box
          sx={{
            paddingTop: '10px',
            borderTop: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography
            variant={'subtitle2'}
            color={lightPalette.text.gray}
            sx={{
              fontWeight: '300',
            }}
          >
            {t('general.updated')}:{' '}
            {formatDate(new Date()?.toISOString(), 'MMMM D, YYYY')}
          </Typography>
        </Box>
      </Card>
    </Grid>
  );
};

export default DashboardChart;
